import angular from 'angular';
import uiRouter from 'angular-ui-router';
import paylocityPayrollDetailCodesComponent from './paylocity-payroll-detail-codes.component';

let paylocityPayrollDetailCodesModule = angular.module('paylocityPayrollDetailCodes', [
  uiRouter,
])

.config(($stateProvider) => {
  "ngInject";

  $stateProvider.state('paylocity-payroll-detail-codes', {
    parent: 'app',
    url: '/admin/integrations/paylocity/payroll-detail-codes',
    data: {
      pageHeader: true,
      pageTitle: 'Paylocity Payroll Detail Codes',
      pageDesc: 'Earnings, deduction, and tax code classifications',
      breadcrumbLink: 'paylocity',
      breadcrumbText: 'Paylocity Capabilities'
    },
    template: '<paylocity-payroll-detail-codes></paylocity-payroll-detail-codes>'
  });

})

.component('paylocityPayrollDetailCodes', paylocityPayrollDetailCodesComponent);

export default paylocityPayrollDetailCodesModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll-detail-codes/paylocity-payroll-detail-codes.js